export default __webpack_public_path__ + "static/media/tyrone.e7effef3.jpg";